<template>
  <div>
    <Modal :footer-hide="false" :mask-closable="false" v-model="show" :title="row.licensePlate" :width="1000" @on-cancel="clearForm()">
      <span class="markerpen">
        <font v-if="row.govAuthStatus == 100" class="CL5">监管待审</font>
        <font v-if="row.govAuthStatus == 200" class="CL4">监管通过</font>
        <font v-if="row.govAuthStatus == 300" class="CL6">监管拒审</font>
      </span>
      <table class="QHtable" v-if="show">
        <tr>
          <th style="width: 100px">车辆信息</th>
          <th></th>
        </tr>
        <tr>
          <td style="width: 125px"><b>车牌号码</b></td>
          <td><carLicense :license="row.licensePlate" :licenseType="row.licenseType"></carLicense></td>
        </tr>
        <tr>
          <td><b>车辆名称</b></td>
          <td>{{ row.name }}</td>
        </tr>
        <tr>
          <td><b>车辆载量</b></td>
          <td>{{ row.carVolume }}m³</td>
        </tr>
        <tr>
          <td><b>车辆类型</b></td>
          <td>
            <span>{{ $CVALUE("carKind", row.carKind) }}</span>
          </td>
        </tr>
        <tr>
          <td><b>运输单位</b></td>
          <td>{{ row.orgName }}</td>
        </tr>
        <tr>
          <td><b>处置证号</b></td>
          <td v-if="!$isblank(row.czznumber)">
            <div class="flex-between">
              <div>
                <span class="MR5 CL4" v-if="$isYouxiaoqiNei(row.startTime, row.endTime)"><i class="MR3 iconfont icon-tongyi"></i>有效期内</span>
                <span class="MR5 CL6" v-else><i class="MR3 iconfont icon-wenhao-quan"></i>有效期外</span>
                <span>{{ row.czznumber }}</span>
                <span style="white-space: nowrap">(有效期{{ $timeFmt(row.startTime, "YYYY年MM月DD日") }}至{{ $timeFmt(row.endTime, "YYYY年MM月DD日") }})</span>
              </div>
            </div>
          </td>
          <td v-else>暂无处置证信息</td>
        </tr>

        <!---排放资质-->
        <tr>
          <th>车辆资质</th>
          <th></th>
        </tr>
        <tr v-if="!row.information500">
          <td colspan="10">暂无证件资质信息</td>
        </tr>
        <tr v-for="(item, index) in row.information500" :key="index">
          <td>
            <b>{{ $s("zizhiTypeTxt", item.zizhiType) || "其他资质" }}</b>
          </td>
          <td>
            <div class="flex-between">
              <div>
                <span class="MR5 CL4" v-if="$isYouxiaoqiNei(item.startTime, item.endTime)"><i class="MR3 iconfont icon-tongyi"></i>有效期内</span>
                <span class="MR5 CL6" v-else><i class="MR3 iconfont icon-wenhao-quan"></i>有效期外</span>
                <span>{{ item.name }}</span>
                <span style="white-space: nowrap">(有效期{{ $timeFmt(item.startTime, "YYYY年MM月DD日") }}至{{ $timeFmt(item.endTime, "YYYY年MM月DD日") }})</span>
              </div>
              <div class="flex-between" style="margin-left: 10px">
                <span class="QHset" style="white-space: nowrap" @click="$openImg($getFritImg(item.url))"> 查看 </span>
              </div>
            </div>
          </td>
        </tr>
        <!---车辆资质 end-->

        <!---监管状态-->
        <tr>
          <th>监管审核</th>
          <th style="text-align: right"></th>
        </tr>
        <tr>
          <td><b>监管状态</b></td>
          <td>{{ $CVALUE("govAuthStatus", row.govAuthStatus) }}</td>
        </tr>
        <tr>
          <td><b>监管意见</b></td>
          <td>{{ row.govAuthStatusNote || "暂无监管意见" }}</td>
        </tr>
        <!---监管状态-->

        <!--审核日志-->
        <tr>
          <th>审核记录</th>
          <th colspan="10"></th>
        </tr>
        <tr v-if="$isblank(row.log)">
          <td colspan="10">暂无审核记录</td>
        </tr>
        <tr v-if="!$isblank(row.log)">
          <td colspan="10">
            <div style="text-align: left; padding: 5px; border-radius: 5px; margin: 5px 0; background: #f5f5f5" v-for="(item, index) in row.log" :key="index">
              <p>{{ $timeFmt(item.created, "YYYY年MM月DD日 HH:mm") }}➥行政单位:{{ item.orgName }}➥账号:{{ item.username }}➥通过:{{ item.app }}</p>
              <p>{{ item.content }}</p>
            </div>
          </td>
        </tr>
        <!---审核日志 end-->
      </table>

      <!---操作区域-->
      <div slot="footer">
        <Button type="success" v-if="scene == 'sceneGov'" @click="$refs.OSgovAuth.hiPop(row.id, 'govAuthCar')">监管审核</Button>
      </div>
      <!---操作区域 end-->
    </Modal>

    <!--弹窗组件区-->
    <OSgovAuth ref="OSgovAuth" @success="reDetailed()"></OSgovAuth>
    <!--弹窗组件区 end-->
  </div>
</template>
<script>
import OSgovAuth from "@/component/OSgovAuth/OSgovAuth";
export default {
  components: {
    OSgovAuth,
  },
  // +----------------------------------------------------------------------
  // | Desc:data
  // +----------------------------------------------------------------------
  data() {
    return {
      show: false,
      isUpdate: false,
      row: {},
    };
  },
  props: {
    scene: {
      type: String,
      required: false,
      default: "sceneUsed",
    },
  },
  methods: {
    // +----------------------------------------------------------------------
    // | Desc:唤起修改
    // +----------------------------------------------------------------------
    hiPop(id) {
      this.$loading(true);
      this.$api.getCarDetailed({ id: id }).then((res) => {
        this.$loading(false);
        if (res.code == 0) {
          this.row = res.data;
          this.show = true;
        } else {
          this.$msg(res.msg, "error");
        }
      });
    },

    // +----------------------------------------------------------------------
    // | Desc:刷新详情
    // +----------------------------------------------------------------------
    reDetailed() {
      this.hiPop(this.row);
      this.isUpdate = true;
    },

    // +----------------------------------------------------------------------
    // | Desc:清理关闭
    // +----------------------------------------------------------------------
    clearForm() {
      this.show = false;
      this.row = {};
      if (this.isUpdate) {
        this.$emit("success");
        this.isUpdate = false;
      }
    },
  },
};
</script>
